<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormStage
      :Stage="editStage"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({ name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormStage from '../components/FormStage.vue';

export default {
  components: {
    FormStage,
  },
  name: 'EditStage',
  module: 'Stages',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing Stage. Default to {}.
      */
      editStage: {},
      /**
       * Query Id for Stage
       */
      stageId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('stages', ['stages', 'stage']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.stageId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_stage(this.stageId);
      this.editStage = this.stage;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('stages', ['LOAD_stage', 'CREATE_stage', 'UPDATE_stage']),
    /** Method used to save the item
     */
    async save(stage) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_stage(stage);
      } else {
        await this.UPDATE_stage(stage);
      }
      this.isSaving = false;
      this.$router.push({ name: 'stage-ListStage' });
    },
  },
};
</script>

<docs>
# EditStage example

'''js
<EditStage :Stage="Stage" />
'''
</docs>
